import React from 'react';
import CollapsibleSectionHOC from '../../../common/CollapsibleSection/CollapsibleSectionHOC.js';
import styles from './manage-taxes.scss';
import InfoTag from '../info-tag/InfoTag.jsx';

const ManageTaxes = props => {
	let { taxObj, toggleTaxSlider, taxSequence, isTempProd, session } = props;
	let taxUpfrontData = [];
	for (var propName in taxObj) {
		if (!taxObj[propName]) {
			delete taxObj[propName];
		}else if(propName === 'HSN/SAC'){
			taxUpfrontData.push({
				key: 'HSN/SAC',
				value: taxObj['HSN/SAC']
			});
		}else if(propName === 'salestax'){
			taxUpfrontData.push({
				key: 'Sales Tax',
				value: taxObj['salestax']
			})
		}
	}
	
	// for (var i in taxSequence) {
	// 	if (taxObj[taxSequence[i]]) {
	// 		taxUpfrontData.push({
	// 			key: taxSequence[i],
	// 			value: taxObj[taxSequence[i]]
	// 		});
	// 	}
	// }

	return (
		<>
			<div
				className={`${styles['taxes-section-container']} ${
					styles['tax-sec']
				} ${styles[isTempProd ? 'border-top-separator' : '']} ${
					Object.keys(taxObj).length ? styles['tax-sec-filled'] : ''
				} ${session.isReadOnly ? 'read-only-mode-taxes-section-container' : ''}`}
				onClick={() => session.isReadOnly ? null : toggleTaxSlider(true)}
			>
				<div className={`${styles['container']}`}>
					<div
						className={`${styles['left-side']} ${
							Object.keys(taxObj).length ? styles['setWidth'] : ''
						}`}
					>
						<div className={styles['head-text']}>
							<span>Taxes</span>
							{/* {taxUpfrontData.length < 2 && !session?.viaOmni ?
							<InfoTag info={'Please Enter Mandatory Fields'} tagIconClass={'icon-alert_outline'} />
							:null} */}
						</div>
						<div className={styles['upfront-data']}>
							{taxUpfrontData.map((ele, index) => (
								<span
									style={{ marginLeft: index != 0 ? 5 : 0 }}
								>
									{ele.key + ': ' + ele.value}{' '}
									{index != 0 ? null : (
										<i className='circle-dot'></i>
									)}{' '}
								</span>
							))}
						</div>
					</div>
					<div className={styles['right-side']}>
						<i className={'icon-Next'}></i>
					</div>
				</div>
			</div>
		</>
	);
};
const ManageTaxesHOC = CollapsibleSectionHOC(ManageTaxes, 'Manage Taxes');

export default ManageTaxesHOC;
